import axios, { CancelTokenSource } from 'axios';
import { useContext, useRef } from 'react';
import useSWR from 'swr';
import {
  AXIOS_CANCEL_MSG, QuoteAssemblyException
} from '../api/models';
import { ConfiguratorContext } from '../context';


interface AssemblyExceptionProps {
  quoteId:string | undefined
  categoryId?:number | undefined
}

export const useAssemblyExceptions = (props?: AssemblyExceptionProps) => {

  const cancelTokenSourceRef = useRef<CancelTokenSource>();
  const configurator = useContext(ConfiguratorContext);

  const fetcher = async ( props?:AssemblyExceptionProps  ) : Promise<QuoteAssemblyException[] | undefined> => {

    if ( !props?.quoteId?.length ) return;

    if ( cancelTokenSourceRef.current ) {
      cancelTokenSourceRef.current.cancel( AXIOS_CANCEL_MSG );
    }
    const cancelSource = axios.CancelToken.source();
    cancelTokenSourceRef.current = cancelSource;

    try {
      const resp = await configurator.api.fetchQuoteAssemblyExceptions(props.quoteId, props.categoryId, cancelSource.token);
      cancelTokenSourceRef.current = undefined;

      return resp.data;
    }
    catch(e: any) {
      const id = e.response?.data?.message || e.message ;
      if ( id === AXIOS_CANCEL_MSG ) return;
      throw e;
    }
  };

  // Use SWR for data fetching
  return useSWR([
    'fetchQuoteAssemblyExceptions',
    props
  ],
    ([_k, p]) => fetcher(p),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval:1
    }
  );
};


export default useAssemblyExceptions;

